import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { useCounter } from '@/hooks/useCounter';
import { STATS } from '@/config/hero';

interface StatItemProps {
    stat: typeof STATS[0] & { isText?: boolean };
    index: number;
    isRTL: boolean;
}

export const StatItem = ({ stat, index, isRTL }: StatItemProps) => {
    const count = useCounter(stat.isText ? 0 : stat.value, 2000, 500 + index * 200);
    const Icon = stat.icon;

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.5 + index * 0.1 }}
            className="flex items-center gap-2"
        >
            <Icon className={cn("w-4 h-4", stat.color)} />
            <span className="text-lg font-bold text-foreground">
                {stat.isText ? stat.suffix : `${count}${stat.suffix}`}
            </span>
            <span className="text-sm text-muted-foreground">
                {isRTL ? stat.labelAr : stat.labelEn}
            </span>
        </motion.div>
    );
};
